// Resolves the Playground's effective model selection. `model` may come from
// user input or a ?model= deep link (Models page "Try in Playground"), so it
// is only honored when it exists in the loaded catalog; anything else falls
// back to the first catalog model, or '' while the catalog is empty.
// Structural type so it works for both the legacy CatalogModel and the
// catalog's CatalogEntry list - only display_name is ever read.
export const resolveSelectedModel = (model: string, models: { display_name: string }[]): string => {
  if (model && models.some((m) => m.display_name === model)) return model;
  return models[0]?.display_name ?? '';
};
